import { render, staticRenderFns } from "./Credential.vue?vue&type=template&id=ed4d0836&"
import script from "./Credential.vue?vue&type=script&lang=js&"
export * from "./Credential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed4d0836')) {
      api.createRecord('ed4d0836', component.options)
    } else {
      api.reload('ed4d0836', component.options)
    }
    module.hot.accept("./Credential.vue?vue&type=template&id=ed4d0836&", function () {
      api.rerender('ed4d0836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Credential/Credential.vue"
export default component.exports